
export type RetsinfoChangeRecordResult =
    { status: 'already fetched', record: RetsinfoHarvestRecord; } |
    { status: 'fetch success', record: RetsinfoHarvestRecord; } |
    { status: 'clientError'; } |
    { status: 'cooldown'; } |
    { status: 'serverError'; };

export type RetsinfoReasonForChange =
    'Unknown' | 'DocumentMetadataChanged' | 'DocumentContentChanged' | 'DocumentMetadataChangedAndDocumentContentChanged' | 'NewDocument' | 'RemovedDocument';

export type RetsinfoHarvestRecord =
    {
        id: string,
        recordYear:number,
        recordMonth: number,
        recordDay: number,
        changes: RetsinfoChange[],
        executedByUserId: string,
        executedTimestamp: Date,
    };

export const RetsinfoRecordFlagValues =
    ['none', 'hide', 'important'] as const;

export type RetsinfoRecordFlagValue = typeof RetsinfoRecordFlagValues[number];

export type RetsinfoChange =
    {
        changeData: RetsinfoChangeData,

        documentData: RetsinfoDocument,

        flag: RetsinfoRecordFlagValue;
    };

export type RetsinfoChangeData =
    {
        documentId: string,
        accessionsnummer: string,
        reasonForChange: RetsinfoReasonForChange,
        changeDate: Date,
        documentType: {
            shortName: string,
            id: number,
        },
        href: string,
        images: {
            source: string,
            altText: string;
        }[];
    };

export type RetsinfoDocument =
    { status: 'not fetched'; } |
    { status: 'error', message: string; } |
    {
        status: 'fetched',
        data:
        {
            documentType: string,
            rank: string,
            accessionNumber: string,
            documentId: string,
            uniqueDocumentId: string,
            documentTitle: string,
            ministry: string;
        };
    };